export const MAX_BRAND_REFERENCES = 20;

export function referenceCountLabel(value) {
  const count = Math.max(0, Number(value) || 0);
  const mod100 = count % 100;
  const mod10 = count % 10;
  let word = "референсов";
  if (mod100 < 11 || mod100 > 14) {
    if (mod10 === 1) word = "референс";
    else if (mod10 >= 2 && mod10 <= 4) word = "референса";
  }
  return `${count} ${word}`;
}
